import React, { useEffect, useState } from "react";
import styles from "./SendEmailConfirmationAccessHS.module.scss";
import { useTranslation } from "react-i18next";
import Modal from "../../UiComponents/modals/Modal";
import { toast } from "react-toastify";
import Axios from "../../../_services/caller.service";
import useModal from "../../../hooks/useModal";
import { MdOutlineMail } from "react-icons/md";

const SendEmailConfirmationAccessHS = ({ login, userMail }) => {
  const { t } = useTranslation();
  const [userToSendEmail, setUserToSendEmail] = useState(null);
  const { isShowing, toggle } = useModal();

  useEffect(() => {
 
    if (userMail && login) {
      setUserToSendEmail({ email: userMail, login:login });
    }
  }, [userMail,login]);
  

  // Open modal with validation
  const openModal = () => {
    if (!userMail || !login) {
      toast.error(t("validation.select_complete_user"));
      return;
    }
    setUserToSendEmail({ email: userMail, login:login });
    toggle();
  };

  // Function to send email confirmation
const sendConfirmationByEmail = async () => {
  if (!userToSendEmail) {
    toast.error(t("email.no_user_selected"));
    return;
  }

  try {
    // Appel API pour envoyer l'email de confirmation
    const response = await Axios.post(`/sendMailToUserToConfirmAccount`, {
      emailToSend: userToSendEmail.email,
      login: userToSendEmail.login
    });

    // Vérifie la réponse du serveur pour confirmer le succès
    if (response.status === 200) {
      toast.success(t("email.sent_successfully"));
      toggle(); // Ferme le modal
    } else {
      // Si le statut n'est pas 200, une erreur s'est produite
      toast.error(t("email.error_sending"));
    }
  } catch (error) {
    // Gestion des erreurs
    console.error("Erreur lors de l'envoi de l'email :", error);
    toast.error(t("email.error_occurred"));
  }
};


  return (
    <>
      <div className={styles.containerSelectUser}>
        <button
          type="button"
          className={styles.btnPrimary}
          onClick={openModal}
          title={t("email.send_confirmation_tooltip")}
        >
          <MdOutlineMail style={{ marginRight: 6 }} />
        </button>
      </div>

      <Modal isShowing={isShowing} hide={toggle}>
        <div className={styles.containerModal}>
          <h2>{t("email.confirmation_title")}</h2>
          <p>
            {t("email.name_label")} <span>{userToSendEmail?.login}</span>
          </p>
          <p>
            {t("email.email_label")} <span>{userToSendEmail?.email}</span>
          </p>

          <button
            type="button"
            className={styles.btnPrimary}
            onClick={sendConfirmationByEmail}
          >
            <MdOutlineMail style={{ marginRight: 6 }} /> {t("email.confirm_send_button")}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default SendEmailConfirmationAccessHS;
